import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import * as Utils from '../lib/utils';
import * as TypeGuards from '../lib/type-guards';
import { EditorWorkflow } from '../lib/editor-workflow.model';
import { WorkflowEditorStore } from '../lib/workflow-editor.store';
import { BackendIntegrationService } from '../lib/backend-integration.service';

import { EditorWorkflowDialogDeleteComponent } from '../workflow-dialog-delete/editor-workflow-dialog-delete.component';

@Component({
    selector: 'eas-editor-workflow-dialog',
    templateUrl: './editor-workflow-dialog.component.html',
    styleUrls: ['./editor-workflow-dialog.component.css'],
    providers: [
        WorkflowEditorStore,
        BackendIntegrationService,
    ],
    standalone: false
})
export class EditorWorkflowDialogComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  dialogTitle = 'Workflow editor';
  assignedBookingItemNameList: string[] = [];

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<EditorWorkflowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      action: 'create'|'edit'|'duplicate',
      workflow: EditorWorkflow,
      assignedBookingItemNameList: string[]
    },
    private integration: BackendIntegrationService,
    private store: WorkflowEditorStore,
  ) { }

  ngOnInit() {
    switch (this.data.action) {
      case 'create':
        this.dialogTitle = $localize `Create a new workflow`;
        this.integration.prepare(undefined).subscribe();
        break;
      case 'edit':
        this.dialogTitle = $localize `Edit the workflow`;
        this.integration.prepare(this.data.workflow.form).subscribe();
        break;
      case 'duplicate':
        this.dialogTitle = $localize `Edit the copy of the workflow`;
        this.integration.prepare({...this.data.workflow.form, id: Utils.guid() }).subscribe();
        break;
    }

    this.assignedBookingItemNameList = this.data.assignedBookingItemNameList;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  canSubmit() {
    return this.store.workflow !== undefined;
  }

  onSubmit() {
    if (!TypeGuards.isDefined(this.store.workflow)) { throw new Error($localize `No workflow!`); }
    this.integration.updateSerializedWorkflow(this.store.workflow);

    // Convert the workflow editor object to an `EditorWorkflow` workflow
    const result: EditorWorkflow = {
      id: this.store.workflow.id,
      name: this.store.workflow.name,
      form: this.integration.workflow.doc.form
    };

    this.dialogRef.close({
      action: this.data.action === 'edit' ? 'edit' : 'create',
      workflow: result
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onDelete() {
    const deleteDialogRef = this.dialog.open(EditorWorkflowDialogDeleteComponent, {
      maxWidth: '400px',
      id: 'workflow-editor-form-dialog'
    });

    deleteDialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.dialogRef.close({
          action: 'delete',
          eligibility: undefined
        });
      }
    });
  }
}
